type PropTypes = {
  className?: string
}

const BranchIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 10"
      className={className}
    >
      <path fill="currentColor" d="M12 6a1.998 1.998 0 0 0-1.93 1.5H8A1.502 1.502 0 0 1 6.5 6V4a2.476 2.476 0 0 0-.513-1.5h4.084a2 2 0 1 0 0-1H3.929a2 2 0 1 0 0 1h.07A1.502 1.502 0 0 1 5.5 4v2A2.503 2.503 0 0 0 8 8.5h2.072A1.997 1.997 0 1 0 12 6Zm0-5a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM2 3a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm10 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z" />
    </svg>
  )
}

export default BranchIcon
